
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.324.5h3.5V4l-1.34-1.34L6.82 6.324 4.496 4l-3.5 3.5-.82-.82 4.32-4.32L6.82 4.683 9.664 1.84 8.324.5z","fill":"#1FDE33"}})])
          )
        }
      }
    